import store from '../store';
import { Toast } from 'vant'
let wsConnection = {
  ws: null,
  messages: {
    questionList: [],
    topList: [],
    tipsList: [],
    giftList: [],
  },
  lockReturn: false,
  timeout: 60 * 1000 * 5,
  timeoutObj: null,
  timeoutNum: null,
  serverTimeoutObj: null,
  //初始化webSocket长连接
  initWebSocket: function (wsurl) {
    this.ws = new WebSocket(wsurl); //写入地址 这里的地址可以在initWebSocket方法加入参数
    this.ws.onopen = this.wsOpen;
    this.ws.onclose = this.wsClose;
    this.ws.onmessage = this.wsMsg;
    this.ws.onerror = this.wsError;
    this.messages.questionList = []
    this.messages.topList = []
    this.messages.tipsList = []
    this.messages.giftList = []
  },
  //打开websocket
  wsOpen: function (e) {
    //开始websocket心跳
    wsConnection.startWsHeartbeat();
    console.log('ws success')
  },
  wsClose: function (e) {
    console.log('ws close')
    let arr = JSON.stringify({})
    store.commit('web_socket_msg', arr)
  },

  wsMsg: function (msg) {
    //每次接收到服务端消息后 重置websocket心跳
    wsConnection.resetHeartbeat();
    let a = JSON.parse(msg.data);
    // operationType 0增加 1删除
    // busType 0聊天 1礼物 2 提醒
    // topflag 0置顶 1不置顶
    // deviceType 0官方 1wap 2 web
    // getall
    if (a instanceof Array) {
      wsConnection.messages.questionList = []
      wsConnection.messages.topList = []
      a.forEach(item => {
        if (item.topFlag === 0) {
          wsConnection.messages.questionList.push(item)
        } else {
          wsConnection.messages.topList.push(item)
        }
      });
    } else {
      // a.seq 获取信息标识
      // Toast.success('操作成功!')
      // 增加 消息类型
      if (a.busType === 0) { // 聊天
        if (a.operationType === 0) { // 增加
          if (a.topFlag === 1) { // 增加置顶
            if (wsConnection.removal(wsConnection.messages.topList, a) == false) {
              wsConnection.messages.topList.unshift(a)
            }
          } else if (a.topFlag === 0) { // 增加非置顶
            if (wsConnection.removal(wsConnection.messages.questionList, a) == false) {
              wsConnection.messages.questionList.unshift(a)
            }
          }
        } else if (a.operationType === 1) { // 删除
          if (a.topFlag === 1) { // 删除置顶
            wsConnection.messages.topList = wsConnection.messages.topList.filter(item => item.seq !== a.seq)
          } else if (a.topFlag === 0) { // 删除非置顶
            wsConnection.messages.questionList = wsConnection.messages.questionList.filter(item => item.seq !== a.seq)
          }
        }
      } else if (a.busType === 1) { // 礼物
        if (wsConnection.removal(wsConnection.messages.giftList, a) == false) {
          wsConnection.messages.giftList.unshift(a)
        }
      } else if (a.busType === 2) { // 提醒
        if (wsConnection.removal(wsConnection.messages.tipsList, a) == false) {
          wsConnection.messages.tipsList.unshift(a)
        }
      }
    }
    let arr = JSON.stringify(wsConnection.messages)
    store.commit('web_socket_msg', arr)
  },
  wsError: function (err) {
    console.log(err, 'ws error');
  },
  removal(list, obj) {
    let isIncolud = false;
    list.forEach(item => {
      if (item.seq == obj.seq) {
        isIncolud = true;
        return
      }
    })
    return isIncolud
  },
  startWsHeartbeat: function () {
    let _this = this;
    _this.timeoutObj && clearTimeout(_this.timeoutObj);
    _this.serverTimeoutObj && clearTimeout(_this.serverTimeoutObj);
    _this.timeoutObj = setInterval(function () {
      //判断websocket当前状态
      if (_this.ws.readyState != 1) {
        _this.reconnect()
      }
    }, _this.timeout);
  },
  //重置websocket心跳
  resetHeartbeat: function () {
    let _this = this;
    clearTimeout(_this.timeoutObj);
    clearTimeout(_this.serverTimeoutObj);
    _this.startWsHeartbeat()
  }
};

//抛出websocket对象
export default wsConnection